"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuadrants = exports.GET_QUADRANTS_FAILURE = exports.GET_QUADRANTS_SUCCESS = exports.GET_QUADRANTS_REQUEST = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _middleware = require("../../../middleware");

var _getMessageStreams = require("../getMessageStreams");

var _index = require("../../../../index");

var _helpers = require("../../../helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var GET_QUADRANTS_REQUEST = 'GET_QUADRANTS_REQUEST';
exports.GET_QUADRANTS_REQUEST = GET_QUADRANTS_REQUEST;
var GET_QUADRANTS_SUCCESS = 'GET_QUADRANTS_SUCCESS';
exports.GET_QUADRANTS_SUCCESS = GET_QUADRANTS_SUCCESS;
var GET_QUADRANTS_FAILURE = 'GET_QUADRANTS_FAILURE';
exports.GET_QUADRANTS_FAILURE = GET_QUADRANTS_FAILURE;

var getQuadrantsRequest = function getQuadrantsRequest() {
  return {
    type: GET_QUADRANTS_REQUEST
  };
};

var getQuadrantsSuccess = function getQuadrantsSuccess(response) {
  return {
    type: GET_QUADRANTS_SUCCESS,
    payload: response
  };
};

var getQuadrantsFailure = function getQuadrantsFailure(error) {
  return {
    type: GET_QUADRANTS_FAILURE,
    payload: error
  };
};

var getQuadrants = function getQuadrants(threshold, universeId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var token, currentState, headers, selectedPersonas, _currentState$quadran, current, quadrants, body, baseUrl, response, currentVal, newCurrentVal, topQuadId;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0, _index.refreshToken)(dispatch);
              dispatch(getQuadrantsRequest());
              token = (0, _index.getAuthToken)();
              currentState = getState();
              headers = {
                'context-organisation': currentState.auth.organisations.currentOrganisation,
                token: token
              }; //add selected personas

              selectedPersonas = currentState.selectedPersonas.personas; //add index threshold

              _currentState$quadran = currentState.quadrants, current = _currentState$quadran.current, quadrants = _currentState$quadran.quadrants;
              body = {
                selectedPersonas: selectedPersonas,
                threshold: threshold,
                universeId: universeId
              };
              baseUrl = (0, _helpers.productEndpoint)();
              _context.next = 12;
              return (0, _middleware.callAPIv2)({
                method: 'POST',
                targetUrl: baseUrl + "/creative-briefs/quadrants",
                // token,
                headers: headers,
                body: body
              });

            case 12:
              response = _context.sent;

              if (!(response instanceof Error)) {
                _context.next = 15;
                break;
              }

              throw response;

            case 15:
              // get current percentage
              currentVal = current ? quadrants.find(function (quadrant) {
                return quadrant.id === current;
              }) : null; // get percentage of current quadrant from response

              newCurrentVal = response.quadrants.find(function (quadrant) {
                return quadrant.id === current;
              }); // if the results of this api call are different to the existing one, then change current selection

              if (!currentVal || !newCurrentVal || currentVal.percentage !== newCurrentVal.percentage) {
                topQuadId = response.quadrants.sort(function (a, b) {
                  return b.percentage - a.percentage;
                })[0].id;
                dispatch((0, _getMessageStreams.setCurrentStream)(topQuadId));
              } // }


              dispatch(getQuadrantsSuccess(response));
              return _context.abrupt("return", response);

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](0);
              dispatch(getQuadrantsFailure(_context.t0.message));

              if (process.env.NODE_ENV !== 'test') {
                Sentry.captureException(_context.t0);
                console.error(_context.t0);
              }

              return _context.abrupt("return", _context.t0);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 22]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getQuadrants = getQuadrants;